export enum ConfigurationSettingsType {
  isTransferFrozen,
}
